export default "https://cdn-static.gokick.com/assets/6909edbc169b94fbe838446b12805066cb856688/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";